import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "react-apollo";

const QUERY = gql`
  query NewTasksCreated($queueId: ID!, $fromTimestamp: Int!, $toTimestamp: Int) {
    newTasksCreated(
      queueId: $queueId
      fromTimestamp: $fromTimestamp
      toTimestamp: $toTimestamp
    )
  }
`;

interface Variables {
  queueId: string;
  fromTimestamp: number;
  toTimestamp?: number;
}

interface Data {
  newTasksCreated: number;
}

export const useNewTasksCreated = (options?: QueryHookOptions<Data, Variables>) =>
  useQuery<Data, Variables>(QUERY, options);
